import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Grid, Typography, Button, TextField, Paper, Radio } from '@material-ui/core'; 
import { getTodayAsISODate, getISODateMonthsFromToday } from "../../../utils/DateUtils";

import useErmaStyling from "../../../hooks/useErmaStyling";
import LoadingIndicator from "../../utils/LoadingIndicator";
import ServiceAPI from "../../../service/ServiceAPI";
import Constants from "../../../utils/Constants";
import HoseTestModel from "../../../model/HoseTestModel";
import { TestResult, Status } from "../../../enums/HoseEnum";


const TestHose = () => {
  const params = useParams();
  const navigate = useNavigate();
  const styling = useErmaStyling();

  const [showLoading, setShowLoading] = useState(true);
  const [hoseRecord, setHoseRecord] = useState(null);
  const [testRecord, setTestRecord] = useState(null);
  const [editCount, setEditCount] = useState(0);

  useEffect(() => {
    ServiceAPI.HoseManagement().getHose(params.hoseId).then((record) => {
      let newTestRecord = new HoseTestModel();
      newTestRecord.setHoseId(record.getId());
      newTestRecord.setTestDate(getTodayAsISODate());

      setHoseRecord(record);
      setTestRecord(newTestRecord);
      setShowLoading(false);
    });
  }, []);

  /**
   * Handles the Cancel button, send user back to the Hose Listing page.
   */
  const handleClick_cancel = () => {
    navigate(Constants.RoutePath.HoseManagement.Listing);
  }

  /**
   * 
   */
  const handleClick_saveTest = () => {
    setShowLoading(true);

    ServiceAPI.HoseManagement().createHoseTest(testRecord).then( (result) => {
      
      if (testRecord.getResult() === TestResult.FAILED) {
        hoseRecord.setStatus(Status.OUT_OF_SERVICE);
        ServiceAPI.HoseManagement().updateHose(hoseRecord);
      }

      navigate(Constants.RoutePath.HoseManagement.Listing);
    });

    
  }

  /**
   * 
   * @param {*} e 
   */
  const handleChange_testDate = (e) => {
    testRecord.setTestDate(e.target.value);
    setTestRecord(testRecord);
    setEditCount(editCount + 1);
  }

  /**
   * 
   * @param {*} e 
   */
  const handleChange_testPressure = (e) => {
    let val = e.target.value;
    
    if (val.match('[^0-9]') || val.length > 4) {
      return;
    }
         
    testRecord.setTestPressureKpa(val);
    setTestRecord(testRecord);
    setEditCount(editCount + 1);
  }

  /**
   * 
   * @param {*} e 
   */
  const handleChange_testResult = (e) => {
    let r = e.target.value;
    testRecord.setResult(r);
    testRecord.setNextTestDueDate(r === TestResult.PASSED ? getISODateMonthsFromToday(12) : null);

    setTestRecord(testRecord);
    setEditCount(editCount + 1);
  }
  
  /**
   * 
   * @param {*} e 
   */
  const handleChange_notes = (e) => {
    testRecord.setNotes(e.target.value);
    setTestRecord(testRecord);
    setEditCount(editCount + 1);
  }  

  /**
   * 
   * @returns 
   */
  const render = () => {
    if (showLoading) {
      return <div><LoadingIndicator isOpen={showLoading} /></div>;
    }

    return (
      <Container className={styling.ermaStyles.container} maxWidth="sm">
        <Grid container justifyContent="space-between" className={styling.ermaStyles.header} xs={12} direction='row'>
          <Grid item xs={12} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Typography className={styling.ermaStyles.sectionHeading}>
              Record Hose Test
            </Typography>
          </Grid>

          <Grid item xs={4} className={[styling.ermaStyles.gridTable_labelField, styling.ermaStyles.gridTable_fieldAlignCenter, styling.ermaStyles.gridTable_fieldAlignLeft].join(" ")}>
            Hose Name
          </Grid>
          <Grid item xs={4} className={[styling.ermaStyles.gridTable_labelField, styling.ermaStyles.gridTable_fieldAlignCenter, styling.ermaStyles.gridTable_fieldAlignLeft].join(" ")}>
            Diameter
          </Grid>
          <Grid item xs={4} className={[styling.ermaStyles.gridTable_labelField, styling.ermaStyles.gridTable_fieldAlignCenter, styling.ermaStyles.gridTable_fieldAlignLeft].join(" ")}>
            Material
          </Grid>

          <Grid item xs={4} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Typography>{hoseRecord.getHoseName()}</Typography>
          </Grid>
          <Grid item xs={4} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Typography>{hoseRecord.getDiameter()}</Typography>
          </Grid>
          <Grid item xs={4} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Typography>{hoseRecord.getMaterial()}</Typography>
          </Grid>


          <Grid item xs={12} sm={6} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <TextField fullWidth variant="outlined" label="Test Date" type="date" InputLabelProps={{ shrink: true }} value={testRecord.getTestDate()} onChange={handleChange_testDate}/>
          </Grid>

          <Grid item xs={12} sm={6} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <TextField fullWidth variant="outlined" label="Test Pressure (kPa)" type="text" value={testRecord.getTestPressureKpa()} onChange={handleChange_testPressure}/>
          </Grid>

          <Grid item xs={12} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Paper 
              elevation={2} 
              className={testRecord.getResult() === TestResult.PASSED ? styling.ermaStyles.success : null} 
              onClick={() => { handleChange_testResult( {target: {value: TestResult.PASSED}} )} }
            > 
              <Radio
                checked={testRecord.getResult() === TestResult.PASSED}
                value={TestResult.PASSED}
                name="radio-test-result"
                inputProps={{ 'aria-label': TestResult.PASSED }}
              />
              Passed
            </Paper>
          </Grid>

          <Grid item xs={12} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Paper 
              elevation={3} 
              className={testRecord.getResult() === TestResult.FAILED ? styling.ermaStyles.danger : null} 
              onClick={ () => handleChange_testResult({target: {value: TestResult.FAILED}} )}
            >
              <Radio
                checked={testRecord.getResult() === TestResult.FAILED}
                value={TestResult.FAILED}
                name="radio-test-result"
                inputProps={{ 'aria-label': TestResult.FAILED }}
              />
              Failed
            </Paper>
          </Grid>

          <Grid item xs={12} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <TextField label="Notes" multiline rows={4} variant="outlined" fullWidth value={testRecord.getNotes()} onChange={handleChange_notes}/>
          </Grid>

          <Grid item xs={6} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Button variant="contained" onClick={handleClick_cancel}>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6} className={styling.ermaStyles.gridTable_rowNoBorder}>
            <Button variant="contained" color="primary" disabled={false} onClick={handleClick_saveTest}>
              Save
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  }

  return render();
}

export default TestHose;